/**
 * mk-wxopen-api
 * 微信开放平台api服务
 *
 * OpenAPI spec version: last
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import ajax, { AjaxPromise, ExtraFetchParams } from '@ajax';
import * as models from '../model/models';

/* tslint:disable:no-unused-variable member-ordering object-literal-shorthand */

/**
  * @description qwIsThirdPartyAppGet参数
  * @property `companyId` companyId,公司账户，必填
  */
export interface ParamsqwIsThirdPartyAppGet {
  // queryParams
  /**
   * companyId,公司账户，必填
   */
  companyId: string;
}

export class IsThreePartAppApi {
  protected $basePath = '/wxopen/v1'.replace(/\/$/, '');

  public constructor(basePath?: string) {
    if (basePath !== undefined) {
      this.$basePath = basePath.replace(/\/$/, '');
    }
  }

  /**
   * 
   * @summary 查询租户企微应用是否是三方应用
   * @param params ParamsqwIsThirdPartyAppGet
   
   * @param opt ajax config
   * @returns models.MiniGetUnlimitWxacode
   */
  public qwIsThirdPartyAppGet = (
    params: ParamsqwIsThirdPartyAppGet,
    opt?: ExtraFetchParams
  ) : AjaxPromise<models.MiniGetUnlimitWxacode>  => {
    const path = '/qw/isThirdPartyApp';
    const url = this.$basePath + path;
    const p: any = {};
    p.query = {};
    if ('companyId' in params) p.query.companyId = params.companyId;
    ajax.check(params.companyId, 'companyId');
    return ajax.ajax({
      ...opt,
      method: 'GET',
      url,
      ...p
    });
  }
}

export default new IsThreePartAppApi();